// Module
var code = `<multiselect
        items="\$ctrl.items"
        label-property="\$ctrl.labelProperty"
        value-property="\$ctrl.valueProperty"
        ng-model="\$ctrl.internalModel"
        ng-model-options="{ allowInvalid: true }"
        select-all-option="true"
        ng-change="\$ctrl.onInternalModelChange()"
        ng-disabled="\$ctrl.ngDisabled"
        ng-required="\$ctrl.ngRequired">
</multiselect>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/multiselect/null-wrapper/multiselect-null-wrapper.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;